export default function getBrowserName (
) {
    var browserNames = ["Chrome", "Firefox", "Edge", "MSIE", "Opera", "Safari", "Brave"];
    for(var i in browserNames) {
    if (window.navigator.userAgent.indexOf(browserNames[i]) > -1) break
    }
    return browserNames[i];
}    
